function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-coins",
    d: "M0 19v2c0 1.655 4.031 3 9 3s9-1.345 9-3v-2c-1.936 1.364-5.475 2-9 2s-7.064-.637-9-2zM15 6c4.969 0 9-1.345 9-3s-4.031-3-9-3-9 1.345-9 3 4.031 3 9 3zM0 14.081V16.5c0 1.655 4.031 3 9 3s9-1.345 9-3v-2.419c-1.936 1.594-5.48 2.419-9 2.419s-7.064-.825-9-2.419zm19.5.516c2.686-.52 4.5-1.486 4.5-2.6V10a11.511 11.511 0 0 1-4.5 1.617zM9 7.5c-4.969 0-9 1.678-9 3.75S4.031 15 9 15s9-1.678 9-3.75S13.969 7.5 9 7.5zm10.28 2.639C22.092 9.633 24 8.639 24 7.5v-2c-1.664 1.177-4.523 1.809-7.533 1.959a5.249 5.249 0 0 1 2.813 2.68z",
    style: {
      fill: "#204bf8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFee);
export default __webpack_public_path__ + "static/media/fee.0c0fe66dd8448352660c6e6af64667b0.svg";
export { ForwardRef as ReactComponent };